import GeneralForm from 'components/Settings/SettingsForm/GeneralForm';
import ColoursForm from 'components/Settings/SettingsForm/ColoursForm';
import BrandingForm from 'components/Settings/SettingsForm/BrandingForm';
import { FaCog, FaGlobeAmericas, FaImage, FaPalette, FaUsers, FaUserTag } from 'react-icons/fa';
import RegionForm from 'components/Settings/SettingsForm/RegionForm';
import Roles from 'components/Settings/Roles';
import Users from 'components/Settings/Users';

const sections = [
  {
    id: 'general',
    description: 'Email receivers, RFQ and FLC settings.',
    text: 'General',
    icon: FaCog,
    route: '/settings',
    component: GeneralForm,
  },
  {
    id: 'branding',
    description: 'Identity, logos and privacy policy settings.',
    text: 'Branding',
    icon: FaImage,
    route: '/settings/branding',
    component: BrandingForm,
  },
  {
    id: 'colours',
    description: 'Text and background colour settings.',
    text: 'Colours',
    icon: FaPalette,
    route: '/settings/colours',
    component: ColoursForm,
  },
  {
    id: 'roles',
    description: 'Define roles to customize page, product and specification access.',
    text: 'Roles',
    datatable: true,
    icon: FaUserTag,
    route: '/settings/roles',
    component: Roles,
  },
  {
    id: 'users',
    description: 'Manage users and their access in the system.',
    text: 'Users',
    datatable: true,
    icon: FaUsers,
    route: '/settings/users',
    component: Users,
  },
  {
    id: 'region',
    description: 'User registration and order country settings.',
    text: 'Region',
    icon: FaGlobeAmericas,
    route: '/settings/region',
    component: RegionForm,
  },
];

export { sections };
